<template>
  <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto space-y-4">
    <StackedField label="Moyen de paiement">
      <template v-if="paymentMethod">
        <span class="flex items-center space-x-2">
          <component
            v-if="paymentMethod.icon"
            :is="iconComponents[this.paymentMethod.icon]"
            class="h-5 w-5 text-primary-dark"
          />
          <span v-html="paymentMethod.label" />
          <PencilIcon class="h-5 cursor-pointer inline-block" @click.stop="copyPaymentMethodLink" />
        </span>
      </template>
    </StackedField>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { HomeIcon, CreditCardIcon } from "@heroicons/vue/outline";
import { StackedField } from "@estaly/ui";
import { toCamelCase } from "@/utils/utils";
import { PencilIcon } from "@heroicons/vue/solid";

export default {
  components: { PencilIcon, CreditCardIcon, StackedField },

  props: ["planSale"],

  computed: {
    paymentMethod() {
      if (!this.paymentMethodData) return null;

      return {
        icon: this.paymentMethodData.type === "card" ? "CreditCardIcon" : "HomeIcon",
        label: `${this.paymentMethodData.brand} **** ${this.paymentMethodData.digits}`,
      };
    },
  },

  data: () => {
    return {
      paymentMethodData: null,
      iconComponents: {
        CreditCardIcon,
        HomeIcon,
      },
    };
  },

  async beforeMount() {
    const response = await this.fetchPaymentMethod({ planSaleId: this.planSale.friendlyId });
    if (response?.success) this.paymentMethodData = toCamelCase(response.data).paymentMethod;
  },

  methods: {
    ...mapActions("planSales", ["fetchPaymentMethod", "fetchUpdatePaymentMethodLink"]),
    ...mapActions("notifications", ["notify"]),

    async copyPaymentMethodLink() {
      const response = await this.fetchUpdatePaymentMethodLink({ planSaleId: this.planSale.friendlyId });
      if (!response?.success) return;

      const paymentLink = toCamelCase(response.data).updateLink;
      this.copyToClipboard(paymentLink);
    },

    copyToClipboard(link) {
      navigator.clipboard.writeText(link).then(async () => {
        await this.notify({
          category: "simple",
          type: "success",
          title: "Lien de modification du moyen de paiement copié",
        });
      });
    },
  },
};
</script>
